export default [
    {
        path: '/jobs',
        name: 'Jobs',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/jobs/JobsIndexAgent.vue'),
        },
    },
];
